import { render, staticRenderFns } from "./NotRegisteredShebaCard.html?vue&type=template&id=3ade93ae&scoped=true&"
import script from "./NotRegisteredShebaCard.js?vue&type=script&lang=js&"
export * from "./NotRegisteredShebaCard.js?vue&type=script&lang=js&"
import style0 from "./NotRegisteredShebaCard.scss?vue&type=style&index=0&id=3ade93ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade93ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCol,VIcon})
